var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v("Access Denied! You do not have permission to access this menu.")])}
var staticRenderFns = []

export { render, staticRenderFns }